var exports = {
  "k": "xdde3148b--4423b3--container",
  "Q": "xdde3148b--4423b3--content",
};

module.exports = exports;
